import { render } from "./OpenInNew.vue?vue&type=template&id=012c1750"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icon/OpenInNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "012c1750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('012c1750', __exports__)) {
    api.reload('012c1750', __exports__)
  }
  
  module.hot.accept("./OpenInNew.vue?vue&type=template&id=012c1750", () => {
    api.rerender('012c1750', render)
  })

}


export default __exports__